// Convert Base64 to ArrayBuffer
function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

// Convert ArrayBuffer to Base64
function arrayBufferToBase64(buffer) {
    const binary = new Uint8Array(buffer);
    let binaryString = "";
    for (let i = 0; i < binary.byteLength; i++) {
        binaryString += String.fromCharCode(binary[i]);
    }
    return btoa(binaryString).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

async function loginWithPasskey() {
    try {
        // Get the username from the input field
        const usernameInput = document.querySelector("input[name='username']");
        const username = usernameInput ? usernameInput.value.trim() : "";

        console.log("Logging in with username:", username);

        // Step 1: Get authentication options from the backend
        const response = await fetch("/auth/options", {
            method: "POST",
            body: JSON.stringify({ username }),
            headers: { "Content-Type": "application/json" },
            credentials: 'include'
        });

        const options = await response.json();
        if (options.error) {
            console.error("Backend error:", options.error_description);
            alert("Error: " + options.error_description);
            return;
        }

        // Step 2: Convert challenge & allowCredentials to ArrayBuffer
        options.challenge = base64ToArrayBuffer(options.challenge);
        if (options.allowCredentials) {
            options.allowCredentials = options.allowCredentials.map(cred => ({
                ...cred,
                id: base64ToArrayBuffer(cred.id)
            }));
        }

        // Step 3: Authenticate user using stored passkey
        const assertion = await navigator.credentials.get({ publicKey: options });

        // Step 4: Create passkeyData to send to PHP
        const passkeyData = {
            id: assertion.id,
            rawId: arrayBufferToBase64(assertion.rawId),
            response: {
                authenticatorData: arrayBufferToBase64(assertion.response.authenticatorData),
                clientDataJSON: arrayBufferToBase64(assertion.response.clientDataJSON),
                signature: arrayBufferToBase64(assertion.response.signature),
                userHandle: assertion.response.userHandle ? arrayBufferToBase64(assertion.response.userHandle) : null
            },
            type: assertion.type
        };

        // Step 5: Submit passkeyData via hidden input field in the form
        const form = document.querySelector("#login-form"); // Ensure form has this ID
        const passkeyInput = document.createElement("input");
        passkeyInput.type = "hidden";
        passkeyInput.name = "passkeyData";
        passkeyInput.value = JSON.stringify(passkeyData);

        form.appendChild(passkeyInput);
        form.submit(); // Submit the form to PHP

    } catch (error) {
        console.error("Fehler bei der Passkey-Anmeldung:", error);
        Swal.fire({
            title: "Fehler",
            text: "Die Passkey-Anmeldung konnte nicht ausgeführt werden! Falls du noch kein Passkey hast, melde dich mit Benutzername und Passwort an.",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok!"
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const passkeyLoginBtn = document.getElementById("passkey-login-btn");
    if (passkeyLoginBtn) {
        passkeyLoginBtn.addEventListener("click", function () {
            loginWithPasskey();
        });
    }
});